import React from "react";

const Footer = () => {
	var d = new Date();
	return (
		<div className="footer position-relative">
			<div className="copyright border-top bg-body w-100 position-sticky top-100 bottom-0 d-flex align-items-center justify-content-center">
				<p>Copyright © {d.getFullYear()} All rights reserved &nbsp;
					<a href="https://atchayapathrafoods.com/" target="_blank"  rel="noreferrer">Atchayapathra Foods Pvt Ltd</a>
				</p>
			</div>
		</div>
	);
};

export default Footer;
